"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cookie2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/cookie"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _client = _interopRequireDefault(require("../utils/client"));

var _capture = _interopRequireDefault(require("../utils/capture"));

/**
 * @function
 * @name SentryCapture - 页面主动上报异常
 * @desc 主动上报前端异常错误
 * @param {string} err 错误信息
 * @param {number} [type=1] 错误类型, 1: 组件级错误，2: 页面级错误， 3: 接口错误，4: 服务器错误，5: 请求失败，6: 请求未知错误，7: promise没有设置catch
 * @param {object} [opts={}] 合并发布对象，例如 {tags: ..., extra: ...}
 * @param {number | object} [limitErrorCnt=3] 主动上报时，除了promise错误，页面错误，接口错误以外的其他错误，同一用户只要超过3次就发送邮件
 * @param
 * @example
 * import { SentryCapture } from '@zz-common/sentry';
 * 
 * // 安装错误异常上报系统
 * SentryCapture('有错误', 1, {
 *  tags: {
 *    test: 'test'
 *  }
 * });
 * 
 * // 需要设置发送邮件规则，同一用户同类型错误发生了多少次才则发送邮件，默认：3；页面级别和promise提示性错误除外
 * SentryCapture('有错误', 1, {
 *  tags: {
 *    test: 'test'
 *  }
 * }, 10);
 * 
 * // 需要设置发送邮件规则，同一用户同类型错误发生了多少次才则发送邮件，默认：3；页面级别和promise提示性错误除外
 * SentryCapture('有错误', 1, {
 *  tags: {
 *    test: 'test'
 *  }
 * }, {
 *  1: 20,
 *  4: 10
 * });
 * 
 * // vue页面级错误捕获，入口文件处
 * Vue.config.errorHandler = (err, vm, info) => {
 *   SentryCapture(err, 2);
 * };
 * 
 * // vue组件级别错误捕获
 * Vue.component('ErrorBoundary', {
 *   data: () => ({ error: null }),
 *   errorCaptured(err, vm, info) {
 *     this.error = `${err.stack}\n\nfound in ${info} of component`;
 *     SentryCapture(this.error, 1);
 *     return false;
 *   },
 *   render(h) {
 *     if (this.error) {
 *       return null;
 *     }
 *     return (this.$slots.default || [null])[0] || null;
 *   },
 * });
 */
var newCapture = function newCapture(err) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var limitErrorCnt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3;
  (0, _capture.default)(err, type, opts, limitErrorCnt, (0, _client.default)(), _cookie2.default, Sentry);
}; // 抓取所有promise没有执行catch的错误


var isServer = void 0 === 'window' ? false : true;

if (!isServer) {
  window.addEventListener('unhandledrejection', function (event) {
    newCapture(event.reason, 7, {
      tags: {
        isSendEmail: 0
      }
    });
  });
}

var _default = newCapture;
exports.default = _default;